// 语言路径工具 —— 单域名 + `/zh` 子目录前缀的多语种路由支持。
// 参考 pm_website 的 src/lib/languagePaths.js，适配 cyberate 的无尾斜杠 URL 惯例
// （首页中文为 /zh/，其余为 /zh/<英文路径>；英文为 / 与 /<路径>）。
//
// basename 技巧：App.js 用 <Router basename="/zh">，使所有 <Link to="/..."> 自动
// 解析到 /zh/...，因此内部链接无需逐个改动。语言切换用 window.location 全页跳转，
// 让 URL 反映语言（爬虫友好）。

export const ZH_PREFIX = '/zh';

// 当前已完整翻译为中文的路径（对应 11 条 MVP 路由，404 通配除外）。
// 用于 SEO 的 hreflang 输出与「未翻译页 zh 侧 noindex」保护：新增英文页面但
// 未补齐 zh 文案时，把它移出此清单即可自动撤回 zh-CN hreflang。
export const ZH_COMPLETE_PATHS = [
  '/',
  '/property-development',
  '/built-environment-investments',
  '/innovation-ventures',
  '/approach',
  '/about',
  '/contact',
  '/submit-opportunity',
  '/privacy',
  '/terms',
];

export const isChinesePath = (pathname = '') => {
  const path = pathname || '/';
  return path === ZH_PREFIX || path.startsWith(`${ZH_PREFIX}/`);
};

export const stripLanguagePrefix = (pathname = '/') => {
  if (!pathname) return '/';
  if (pathname === ZH_PREFIX) return '/';
  if (pathname.startsWith(`${ZH_PREFIX}/`)) {
    const stripped = pathname.slice(ZH_PREFIX.length);
    return stripped || '/';
  }
  return pathname;
};

export const addChinesePrefix = (pathname = '/') => {
  if (!pathname || pathname === '/') return `${ZH_PREFIX}/`;
  if (isChinesePath(pathname)) return pathname;
  return pathname.startsWith('/') ? `${ZH_PREFIX}${pathname}` : `${ZH_PREFIX}/${pathname}`;
};

export const getLanguageFromPath = (pathname = '') => (isChinesePath(pathname) ? 'zh' : 'en');

// 语言切换：返回目标语言下的同页面完整路径（含 search/hash），供 window.location 跳转。
export const switchLanguagePath = (pathname = '/', search = '', hash = '', nextLanguage = 'en') => {
  const basePath = stripLanguagePrefix(pathname || '/');
  const nextPath = nextLanguage === 'zh' ? addChinesePrefix(basePath) : basePath;
  return `${nextPath}${search || ''}${hash || ''}`;
};

// 判断某路径（已剥离语言前缀）是否有完整中文翻译。
export const isZhComplete = (path) => ZH_COMPLETE_PATHS.includes(path);
